/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

/**
 * create a global EventBus to emit and listen to system-wide events
 *
 * USAGE EXAMPLE
 *
 * EventBus.$on("test", payload => alert(payload));
 * app.manager.bind("test", payload => alert(payload));
 *
 * EventBus.$emit("test", "huhu");
 * app.manager.trigger("test", "huhu1");
 * app.manager.safeTrigger("test", "huhu2");
 *
 */
import Vue from 'vue';
export const EventBus = new Vue();

/**
 * also implement the "old" app.manager API like events
 */

EventBus.bind = EventBus.$on;
EventBus.unbind = EventBus.$off;
EventBus.trigger = EventBus.$emit;
EventBus.safeTrigger = function(event, context) {
	try {
		return this.trigger(event, context);
	} catch (e) {
		return notifyProgrammingError("error when triggering binding for event " + event + ": ", e);
	}
};

/**
 * And publish EventBus also as window.app.manager
 */
if (typeof window.app !== "object") {
	window.app = {};
}
window.app.manager = EventBus;
